import platform from '@/shared/utils/platform';
import {
  Component, Vue,
} from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { HomeThemeEnums } from '@/shared/utils/pageTheme';

import style from './index.module.scss';

const HomeStore = namespace('home');

@Component
export default class AdvantageList extends Vue {
  @HomeStore.State homeThemeType!: HomeThemeEnums;

  private get aliMiniAndDingTalk() {
    return platform.isAlipayMini || platform.isDingTalk;
  }

  private render() {
    return (
      <ul class={[style['feature-list'], this.aliMiniAndDingTalk && style.bottom]}>
        <li class={style['feature-item']}>
          <span class={[style.icons, style.loan]}></span>
          <span>息费透明</span>
        </li>
        <li class={style['feature-item']}>
          <span class={[style.icons, style.seconds]}></span>
          <span>最快3分钟放款</span>
        </li>
        <li class={style['feature-item']}>
          <span class={[style.icons, style.circle]}></span>
          <span>循环额度</span>
        </li>
      </ul>
    );
  }
}
